import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	name: string;
	brandFieldName: string;
	testId: string;
	onChange: (value: Nullable<number>) => void;
}

export const MccField: React.FC<IProps> = React.memo(({ name, brandFieldName, testId, onChange }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldValue }) => ({
				validator: (_, value) => {
					if (getFieldValue(brandFieldName) && !value) {
						return Promise.reject(new Error(t('enterMcc')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t, brandFieldName],
	);

	return (
		<FormInputNew
			testId={testId}
			type="number"
			min={1000}
			max={9999}
			name={name}
			label="mccLabel"
			validationRules={validationRules}
			onChangeNumber={onChange}
		/>
	);
});
